export default __webpack_public_path__ + "static/media/backimghome.01e5dd16.png";